import { useEffect } from "react";

let openPopups = 0;
let previousOverflow = "";

export default function usePopupScrollLock() {
  useEffect(() => {
    if (openPopups === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    openPopups += 1;
    return () => {
      openPopups -= 1;
      if (openPopups === 0) document.body.style.overflow = previousOverflow;
    };
  }, []);
}
